import React from 'react'
import ReactMarkdown from 'react-markdown'

import ItemTemplate from './ItemTemplate'
import { ModalExpenseEditor } from '../../components/ExpenseEditor.jsx'

import { nameOrTitle } from '../../lib/text.js'
import { linkifyMarkdown } from "../../../lib/Tools"

/**
 *
 */

const Expense = props => {
  const { item, routeId, i, editItem } = props
  const referencedExpense = JSON.parse(props.referencedExpense)
  const expense = (referencedExpense && referencedExpense.expense)  || item.expense

  const customFee = expense.useCustomFee ? `${expense.customFee}%` : null

  return (
    <ItemTemplate
      {...props}
      title={nameOrTitle(expense) || " - "}
      subtitle={""}
      description={
        <div>
          {(customFee) && (<div>{customFee && <div>Gastos gestión: {customFee}</div>}</div>)}
          {expense.notes && (<ReactMarkdown source={linkifyMarkdown(expense.notes)} />)}
        </div>
      }
      icon={expense.type == "hotel" ? "bed" : "euro"}
      modal={
        () => (
          <ModalExpenseEditor
            agendaItem={item}
            routeId={routeId}
            referencedExpense={referencedExpense}
            i={i}
            expense={expense}
            editItem={editItem}
            onClose={() => props.onEndEdit()}ç
            withExceptions={false}
            onChange = {changes => editItem(
              routeId,
        referencedExpense ? referencedExpense.index : i,
        "expense",
        {
          ...(referencedExpense ? referencedExpense.expense : expense),
          ...changes
        }
      )}
            pickCity
            pickType
          />
        )
      }
    />
  )
}

export default Expense
